import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrganizationalUnitDataService, OrganizationalUnitModel } from '../../services/organizational-unit-data.service';

@Component({
  selector: 'app-organizational-units-add-dialog',
  templateUrl: './organizational-units-add-dialog.component.html',
  styleUrls: ['./organizational-units-add-dialog.component.css'],
})
export class OrganizationalUnitsAddDialogComponent implements OnInit {
  adding = false;
  originalFormValues: any;

  unitData: OrganizationalUnitModel = {
    code: '',
    name: '',
  };

  unitDataEdit: OrganizationalUnitModel = {
    code: '',
    name: '',
  };

  constructor(
    public ouDataService: OrganizationalUnitDataService,
    public dialogRef: MatDialogRef<OrganizationalUnitsAddDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public importingData: { action: string; data?: OrganizationalUnitModel }
  ) {}

  ngOnInit(): void {
    if (this.importingData?.data) {
      this.unitDataEdit = { ...this.importingData.data };
      this.originalFormValues = { ...this.unitDataEdit };
    }
  }

  async addNewUnitFromDialog() {
    this.adding = true;
    await this.ouDataService.addUnit(this.unitData);
    this.adding = false;
    this.dialogRef.close('res');
  }

  editUnitFromDialog() {
    this.ouDataService.editUnit(this.unitDataEdit);
    this.dialogRef.close();
  }

  isFormDirty(): boolean {
    return JSON.stringify(this.originalFormValues) !== JSON.stringify(this.unitDataEdit);
  }

  isFormValid(): boolean {
    if (this.importingData?.action === 'Add') {
      return !!(this.unitData.code && this.unitData.name);
    } else {
      return !!(this.unitDataEdit.code && this.unitDataEdit.name);
    }
  }
}
